class OwnerMap
  constructor: (@container) ->
    id = @container.attr('id')
    zoom = @container.data('zoom')

    map_options = {
      center: new google.maps.LatLng(@container.data('longitude') || 0,  @container.data('latitude') || 0),
      mapTypeControl: true,
      zoom: zoom
    }
    googleMap = new google.maps.Map(document.getElementById(id), map_options)
    locations = @container.data('locations')
    $.each locations, (index, location) ->
      new google.maps.Marker({
        position: new google.maps.LatLng(location.latitude, location.longitude),
        icon: location.icon,
        map: googleMap,
      })

    window.googleMap = googleMap


$(window).on "load", ->
  $("*[data-behavior=OwnerMap]").each ->
    new OwnerMap($(@))
